import React, { createContext, useContext, useState, useMemo } from 'react';

interface MedicalCardLoadingContextType {
    isLoading: boolean;
    setIsLoading: (loading: boolean) => void;
}

const MedicalCardLoadingContext = createContext<MedicalCardLoadingContextType | undefined>(undefined);

export const MedicalCardLoadingProvider = ({ children }: { children: React.ReactNode }) => {
    const [isLoading, setIsLoading] = useState(false);

    const value = useMemo(() => ({
        isLoading,
        setIsLoading
    }), [isLoading]);

    return (
        <MedicalCardLoadingContext.Provider value= { value } >
        { children }
        </MedicalCardLoadingContext.Provider>
    );
};

export const useMedicalCardLoading = () => {
    const context = useContext(MedicalCardLoadingContext);
    if (context === undefined) {
        return {
            isLoading: false,
            setIsLoading: () => { }
        };
    }
    return context;
};
